import { __awaiter, __generator } from "tslib";
import { getFileLocationUrl, hasOpenFileLocationCapability, } from '@office-start/file-utility';
import { launchFolder, launchUrl } from '@office-start/launcher-service';
export function createOpenFileLocationAction(item) {
    var _this = this;
    if (!hasOpenFileLocationCapability(item)) {
        return undefined;
    }
    var targetUrl = getFileLocationUrl(item);
    if (!targetUrl) {
        return undefined;
    }
    return function () { return __awaiter(_this, void 0, void 0, function () {
        var action;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!item.isLocalFile) return [3 /*break*/, 2];
                    return [4 /*yield*/, launchFolder(targetUrl)];
                case 1:
                    _a.sent();
                    return [3 /*break*/, 4];
                case 2:
                    action = 'OpenFileLocation';
                    return [4 /*yield*/, launchUrl(targetUrl, { action: action })];
                case 3:
                    _a.sent();
                    _a.label = 4;
                case 4: return [2 /*return*/];
            }
        });
    }); };
}
//# sourceMappingURL=createOpenFileLocationAction.js.map